import { Dropdown, Menu } from 'antd'
import { MyBtn } from '../ui/MyBtn'
import { FilterOutlined } from '@ant-design/icons'
import { useState } from 'react'

export interface FitlerItemProps {
  key: string
  name: string
}

export const PageFilter: React.FC<{
  data: FitlerItemProps[]
  onChange: (item: FitlerItemProps, index: number) => void
}> = ({ data, onChange }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const onFilterItem = (item: FitlerItemProps, index: number) => {
    setCurrentIndex(index)
    onChange(item, index)
  }

  return (
    <Dropdown
      overlay={
        <Menu
          items={data?.map((item, index) => {
            return {
              label: (
                <a
                  href="#!"
                  onClick={e => {
                    e.preventDefault()
                    onFilterItem(item, index)
                  }}
                >
                  {item.name}
                </a>
              ),
              key: item.key,
            }
          })}
        />
      }
    >
      <MyBtn type="default" style={{ padding: '3px 12px', height: 32 }} ghost>
        {data?.[currentIndex].name} <FilterOutlined />
      </MyBtn>
    </Dropdown>
  )
}
